export const lightColors = {
  input: {
    background: '#f4f5f7',
    border: '#e5e7eb',
    color: '#24262d',
    placeholder: '#4c4f52',
    shadow: 'rgba(202, 191, 253, .45)',
    borderFocus: '#cabffd',
  },
  switch: {
    background: '#C0CCDA',
    thumb: '#fff',
    active: '#791ace',
  },
  primary: {
    main: '#791ace',
    light: '#bb8ce6',
  },
  secondary: {
    main: '#f0d609',
    light: '#f7ea83',
  },
  radio: {
    border: '#e2e8f0',
  },
  button: {
    active: '#6c2bd9',
    outlined: '#24262d',
    warning: {
      background: '#f0d60b',
      hover: '#eded2e',
      color: '#000',
    },
  },
  card: {
    color: '#4c4f52',
    background: '#fff',
  },
  datepicker: {
    background: '#fff',
    driver: '#d8d8d8',
    color: '#2D3748',
    disabled: '#EBEAEA',
    selected: {
      background: '#34a1ff',
      color: '#fff',
    },
  },
  notification: {
    border: '#f1f1f1',
    header: '#f1f1f1',
  },
  note: {
    backgroundColor: '#f0d60b4d',
  },
  loading: {
    wrapperBg: '#f9fafb',
    bg: '#fff',
    lds: '#791ace',
  },
  table: {
    borderCell: '#e5e7eb',
    bgHeader: '#f9fafb',
    bgRowOld: '#fff',
    bgRowEven: '#f4f5f7',
    hover: '#d5d6d7',
  },
  item: {
    odd: '#EAEAEA',
    even: '#F5F5F5',
  },
};

export const darkColors = {
  input: {
    background: '#24262d',
    border: '#e5e7eb',
    color: '#e5e7eb',
    placeholder: '#4c4f52',
    shadow: 'rgba(202, 191, 253, .45)',
    borderFocus: '#cabffd',
  },
  switch: {
    background: '#C0CCDA',
    thumb: '#fff',
    active: '#791ace',
  },
  primary: {
    main: '#791ace',
    light: '#bb8ce6',
  },
  secondary: {
    main: '#f0d609',
    light: '#f7ea83',
  },
  radio: {
    border: '#e2e8f0',
  },
  button: {
    active: '#6c2bd9',
    outlined: '#4c4f52',
    warning: {
      background: '#f0d60b',
      hover: '#eded2e',
      color: '#000',
    },
  },
  card: {
    color: '#d5d6d7',
    background: '#1a1c23',
  },
  datepicker: {
    background: '#1a1c23',
    driver: '#4a4b50',
    color: '#2D3748',
    disabled: '#8b8282',
    selected: {
      background: '#34a1ff',
      color: '#fff',
    },
  },
  notification: {
    border: '#4a4a4a',
    header: '#24262d',
  },
  note: {
    backgroundColor: '#b6a203',
  },
  loading: {
    wrapperBg: '#121317',
    bg: '#1a1c23',
    lds: '#791ace',
  },
  table: {
    borderCell: '#24262d',
    bgHeader: '#1a1c23',
    hover: '#4c4f52',
    bgRowOld: '#000',
    bgRowEven: '#1a1c23',
  },
  item: {
    odd: '#24262d',
    even: '#353639',
  },
};
